// LT-183: NO-AUTH client for /book/{slug}. This endpoint is public
// (contact, not workspace user) so we bypass the auth interceptor.
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;
if (!API_BASE_URL) {
  throw new Error('REACT_APP_API_URL environment variable is required');
}

const client = axios.create({ baseURL: API_BASE_URL, timeout: 30000 });

export interface Slot {
  start: string;
}

export interface AvailabilityResponse {
  slug: string;
  title: string;
  duration_minutes: number;
  timezone: string;
  owner_name?: string | null;
  slots: Slot[];

  // LT-511: revamp fields. All nullable.
  owner_avatar_url?: string | null;
  description?: string | null;
  location_label?: string | null;
}

export interface BookingRequest {
  start_time: string;
  contact_name: string;
  contact_email: string;
  enrollment_token?: string | null;

  // LT-511: optional "What should we cover?" textarea.
  notes?: string | null;
}

export interface BookingResponse {
  meeting_id: string;
  status: string;
}

export const publicBookingAPI = {
  getAvailability: async (slug: string): Promise<AvailabilityResponse> => {
    const r = await client.get<AvailabilityResponse>(`/book/${slug}`);
    return r.data;
  },
  book: async (slug: string, body: BookingRequest): Promise<BookingResponse> => {
    const r = await client.post<BookingResponse>(`/book/${slug}`, body);
    return r.data;
  },
};
